<template>
  <generic-modal :title="$t('medical service')" ref="generic_modal">
    <div class="form">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("date") }}</label>
            <div class="control">
              <input class="input" type="date" v-model="meta.date" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('medical service')"
              :is_multiple="false"
              :placeholder="$t('select one')"
              url="/patient/medical-service/catalog"
              name_field="name"
              value_field="medical_service_id"
              @selected="set_medical_service"
              ref="medical_service_dropdown"
              :add_new="false"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('doctor')"
              :is_multiple="false"
              :placeholder="$t('select one')"
              url="/patient/team/catalog"
              name_field="name"
              value_field="team_member_id"
              @selected="set_team_doctor"
              ref="doctor_dropdown"
              :add_new="false"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("price") }}</label>
            <div class="control">
              <input class="input" type="number" v-model="meta.price" />
            </div>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("description") }}</label>
        <div class="control">
          <textarea
            class="textarea"
            rows="2"
            v-model="meta.description"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <!-- <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  get,
  post,
  error_alert,
  download,
  generate_error_message_text,
  get_currency_settings,
  api_host,
  input_alert,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import moment from "moment";

export default {
  name: "DocumentModal",
  components: {
    GenericModal,
    GenericDropdown,
  },
  data() {
    return {
      api_host,
      meta: { settings: {} },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.date || !v.meta.medical_service_id;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    create() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit(medical_service_uuid) {
      let v = this;
      v.set_initial_state();

      get("/patient/patient-medical-service", { uuid: medical_service_uuid })
        .then((document) => {
          v.meta = document;

          if (document.medical_service_id)
            v.$refs.medical_service_dropdown.set_value(
              document.medical_service_id
            );

          if (document.doctor_member_id)
            v.$refs.doctor_dropdown.set_value(document.doctor_member_id);

          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
          v.$refs.generic_modal.show_modal();
        });
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      data.patient_uuid = v.$route.params.patient_uuid;
      if (!v.meta.uuid)
        put("/patient/patient-medical-service", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/patient/patient-medical-service", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      v.$refs.medical_service_dropdown.clear();
      v.$refs.doctor_dropdown.clear();
      // v.uuid = "";
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete medical service?"),
        v,
        () => {
          del("/patient/patient-medical-service", { uuid: v.meta.uuid })
            .then(() => {
              v.$emit("success");
              v.$refs.generic_modal.close_modal();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    set_medical_service(medical_service) {
      let v = this;
      if (medical_service)
        v.meta.medical_service_id = medical_service.medical_service_id;
    },
    set_team_doctor(doctor) {
      let v = this;
      if (doctor) v.meta.doctor_team_member_id = doctor.team_member_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
